import { useEffect, useState } from "react";
import { ConstantImport } from "../Constants/ConstantImport";
import { NewTabLink } from "./UI/NewTabLink";
import { Link } from "react-router-dom";

type KXAccommProps = {
    StatusFlag: string;
    StatusDescription: string;
    KxStudentGuid: string;
    ApplicationTypeID: number;
    Campus: string;
    StudyLevel: string;
    NavTo: string;
}

export function KXAccomm(props: KXAccommProps) {
    let Campus = props.Campus?.toUpperCase();
    let StudyLevel = props.StudyLevel?.toUpperCase();

    const [LabelKx, setLabelKx] = useState("");
    const [LinkButtonKx, setLinkButtonKx] = useState("");
    const [LinkButtonKxDeposit, setLinkButtonKxDeposit] = useState("");
    const [LabelKxTitleVisible, setLabelKxTitleVisible] = useState(false);
    const [LabelKxVisible, setLabelKxVisible] = useState(false);
    const [HyperlinkKxDefaultVisible, setHyperlinkKxDefaultVisible] = useState(false);
    const [LinkButtonKxVisible, setLinkButtonKxVisible] = useState(false);
    const [LinkButtonKxDepositVisible, setLinkButtonKxDepositVisible] = useState(false);

    useEffect(() => {

        let _setLabelKx = "";
        let _setLinkButtonKx = "";
        let _setLinkButtonKxDeposit = "";
        let _setLabelKxTitleVisible = false;
        let _setLabelKxVisible = false;
        let _setHyperlinkKxDefaultVisible = false;
        let _setLinkButtonKxVisible = false;
        let _setLinkButtonKxDepositVisible = false;

        //should know from status flag what to do now...
        //only APPLY and APPLYINCOMPLETE need piping through the contract style INTRO page.
        //rest can have direct links back into KX web pages
        //public enum AccommStatusFlag

        switch (props.StatusFlag) {
            case "UNKNOWN":
                //My Accommodation Applications: [We are unable to determine your application status]. If you have a question about Accommodation Services, please see the Accommodation Services website.

                if (props.StatusDescription === null) {
                    props.StatusDescription = "We are unable to determine your application status";
                }
                _setLabelKx = props.StatusDescription + ". If you have a question about Accommodation Services, please see the ";
                break;

            //SS removed Oct 2014 - as OFFER and ACCEPT are coped with by KxOffers.ascx instead
            //------------------------------------------------------------------
            //case kxApplication.AccommStatusFlag.ACCEPT:
            //    //My Accommodation Applications: [You have accepted an offer of accommodation].
            //    LabelKxTitle.Visible = true;
            //    LabelKxError.Visible = false;
            //    LabelKx.Visible = true;
            //    LabelClickWait.Visible = false;
            //    HyperlinkKxDefault.Visible = false;
            //    if (props.KxStudentGuid != null)
            //    {
            //        LinkButtonKx.Visible = true;
            //        setLinkButtonKx("View accepted accommodation offer and/or complete your eInduction to accommodation at Essex.";
            //    }
            //    if (props.KxStudentGuid === null)
            //    {
            //        LinkButtonKx.Visible = false;
            //    }
            //    LinkButtonKxDeposit.Visible = false;
            //    setLabelKx(props.StatusDescription.ToString() + ".";
            //    break;

            case "ACCEPT":
                //My Accommodation Applications: [You have accepted an offer of accommodation].
                _setLabelKxTitleVisible = false;
                _setLabelKxVisible = false;
                _setHyperlinkKxDefaultVisible = false;
                _setLinkButtonKxVisible = false;
                _setLinkButtonKxDepositVisible = false;
                break;

            case "APPLY":
                //My Accommodation Applications: [You do not have an application]. Apply for accommodation (to start in XXXXX) online.
                _setLabelKxTitleVisible = true;
                _setLabelKxVisible = true;
                _setHyperlinkKxDefaultVisible = false;
                _setLinkButtonKxDepositVisible = false;
                _setLabelKx = props.StatusDescription + ". ";
                _setLinkButtonKxVisible = true;

                //waiting lists
                //props.ApplicationTypeID === 23	//UG Waiting List
                //props.ApplicationTypeID === 24	//PG Waiting List
                //props.ApplicationTypeID === 68	//UG Waiting List Southend
                //props.ApplicationTypeID === 69)// PG Waiting List Southend

                //note only waiting list/October starters catered for - not Jan/April starts.

                switch (Campus) {
                    case "COLCHESTER":
                        _setLinkButtonKx = "Apply for Colchester Campus accommodation (to start in October) online.";
                        //different wording for waiting lists.
                        if (StudyLevel === "UNDERGRADUATE") {
                            if (props.ApplicationTypeID === 23) {
                                _setLinkButtonKx = "Apply for undergraduate accommodation waiting list / late booking (Colchester Campus) online.";
                            }
                        }
                        if (StudyLevel === "POSTGRADUATE") {
                            if (props.ApplicationTypeID === 24) {
                                _setLinkButtonKx = "Apply for postgraduate accommodation waiting list / late booking (Colchester Campus) online.";
                            }
                        }
                        break;
                    case "SOUTHEND":
                        _setLinkButtonKx = "Apply for Southend Campus accommodation (to start in October) online.";
                        //different wording for waiting lists.
                        if (StudyLevel === "UNDERGRADUATE") {
                            if (props.ApplicationTypeID === 23) {
                                _setLinkButtonKx = "Apply for undergraduate accommodation waiting list / late booking (Southend Campus) online.";
                            }
                        }
                        if (StudyLevel === "POSTGRADUATE") {
                            if (props.ApplicationTypeID === 24) {
                                _setLinkButtonKx = "Apply for postgraduate accommodation waiting list / late booking (Southend Campus) online.";
                            }
                        }
                        break;
                    default:
                        break;
                }


                break;
            case "APPLYINCOMPLETE":
                //My Accommodation Applications: [You do not have an application]. Apply for accommodation (to start in XXXXX) online.
                _setLabelKxTitleVisible = true;
                _setLabelKxVisible = true;
                _setHyperlinkKxDefaultVisible = false;
                _setLinkButtonKxDepositVisible = false;
                _setLabelKx = props.StatusDescription + ".";
                _setLinkButtonKxVisible = true;

                //waiting lists
                //props.ApplicationTypeID === 23	//UG Waiting List
                //props.ApplicationTypeID === 24	//PG Waiting List
                //props.ApplicationTypeID === 68	//UG Waiting List Southend
                //props.ApplicationTypeID === 69)// PG Waiting List Southend

                //note only waiting list/October starters catered for - not Jan/April starts.

                switch (Campus) {
                    case "COLCHESTER":
                        _setLinkButtonKx = "Complete your application for Colchester Campus accommodation (to start in October) online.";
                        //different wording for waiting lists.
                        if (StudyLevel === "UNDERGRADUATE") {
                            if (props.ApplicationTypeID === 23) {
                                _setLinkButtonKx = "Complete your undergraduate waiting list / late booking application for Colchester Campus accommodation online.";
                            }
                        }
                        if (StudyLevel === "POSTGRADUATE") {
                            if (props.ApplicationTypeID === 24) {
                                _setLinkButtonKx = "Complete your postgraduate waiting list / late booking application for Colchester Campus accommodation online.";
                            }
                        }
                        break;

                    case "SOUTHEND":
                        _setLinkButtonKx = "Complete your application for Southend Campus accommodation (to start in October) online.";
                        //different wording for waiting lists.
                        if (StudyLevel === "UNDERGRADUATE") {
                            if (props.ApplicationTypeID === 68) {
                                _setLinkButtonKx = "Complete your undergraduate waiting list / late booking application for Southend Campus accommodation online.";
                            }
                        }
                        if (StudyLevel === "POSTGRADUATE") {
                            if (props.ApplicationTypeID === 69) {
                                _setLinkButtonKx = "Complete your postgraduate waiting list / late booking application for Southend Campus accommodation online.";
                            }
                        }
                        break;
                }
                break;
            case "COMPLETE":
                //My Accommodation Applications: [Your application has been received].
                _setLabelKxTitleVisible = true;
                //LabelKxError.Visible = false;
                _setLabelKxVisible = true;
                _setHyperlinkKxDefaultVisible = false;
                _setLinkButtonKxVisible = false;
                //LabelClickWait.Visible = false;
                _setLinkButtonKxVisible = false;

                _setLabelKx = props.StatusDescription.replace("and has been processed", "").trim();
                break;
            case "INDUCTED":
                //My Accommodation Applications: [You have accepted an offer of accommodation and completed e-induction].
                _setLabelKxTitleVisible = true;
                _setLabelKxVisible = true;
                _setHyperlinkKxDefaultVisible = false;
                if (props.KxStudentGuid != null) {
                    _setLinkButtonKxVisible = true;
                    _setLinkButtonKx = "View details of accepted accommodation and review completed e-induction.";
                }
                if (props.KxStudentGuid === null) {
                    _setLinkButtonKxVisible = false;
                }
                _setLinkButtonKxDepositVisible = false;
                _setLabelKx = props.StatusDescription + ".";
                break;


            //SS removed Oct 2014 - as OFFER and ACCEPT are coped with by KxOffers.ascx instead
            //------------------------------------------------------------------
            //case kxApplication.AccommStatusFlag.OFFER:
            //    //My Accommodation Applications: [You have a pending offer of accommodation].
            //    LabelKxTitle.Visible = true;
            //    LabelKxError.Visible = false;
            //    LabelKx.Visible = true;
            //    LabelClickWait.Visible = false;
            //    HyperlinkKxDefault.Visible = false;
            //    if (props.KxStudentGuid != null)
            //    {
            //        LinkButtonKx.Visible = true;
            //        setLinkButtonKx("View (and accept or reject) this accommodation offer.";
            //    }
            //    if (props.KxStudentGuid === null)
            //    {
            //        LinkButtonKx.Visible = false;
            //    }
            //    LinkButtonKxDeposit.Visible = false;
            //    setLabelKx(props.StatusDescription.ToString().Trim() + ".";
            //    break;

            case "OFFER":
                //My Accommodation Applications: [You have a pending offer of accommodation].
                _setLabelKxTitleVisible = false;
                _setLabelKxVisible = false;
                _setHyperlinkKxDefaultVisible = false;
                _setLinkButtonKxVisible = false;
                _setLinkButtonKxDepositVisible = false;
                break;

            case "REJECT":
                //My Accommodation Applications: [You have rejected an offer of accommodation].
                //waiting lists only: they get a second chance to apply, unlike returners
                if (props.ApplicationTypeID === 23	//UG Waiting List
                    || props.ApplicationTypeID === 24	//PG Waiting List
                    || props.ApplicationTypeID === 68	//UG Waiting List Southend
                    || props.ApplicationTypeID === 69)// PG Waiting List Southend
                {
                    _setLabelKxTitleVisible = true;
                    _setLabelKxVisible = true;
                    _setHyperlinkKxDefaultVisible = false;
                    _setLinkButtonKxDepositVisible = false;
                    _setLabelKx = "You have previously rejected, or you have been rejected for, an offer of accommodation.";
                    if (props.KxStudentGuid !== null) {
                        _setLinkButtonKxVisible = true;
                    }
                    if (props.KxStudentGuid === null) {
                        _setLinkButtonKxVisible = false;
                    }

                    switch (Campus) {
                        case "COLCHESTER":
                            if (StudyLevel === "UNDERGRADUATE") {
                                _setLinkButtonKx = "Re-apply for undergraduate accommodation waiting list / late booking (Colchester Campus) online.";
                            }
                            if (StudyLevel === "POSTGRADUATE") {
                                _setLinkButtonKx = "Re-apply for postgraduate accommodation waiting list / late booking (Colchester Campus) online.";
                            }
                            break;
                        case "SOUTHEND":
                            if (StudyLevel === "UNDERGRADUATE") {
                                _setLinkButtonKx = "Re-apply for undergraduate accommodation waiting list / late booking (Southend Campus) online.";
                            }
                            if (StudyLevel === "POSTGRADUATE") {
                                _setLinkButtonKx = "Re-apply for postgraduate accommodation waiting list / late booking (Southend Campus) online.";
                            }
                            break;
                        default:
                            break;
                    }

                }
                else {
                    _setLabelKxTitleVisible = true;
                    _setLabelKxVisible = true;
                    _setHyperlinkKxDefaultVisible = false;
                    _setLinkButtonKxVisible = false;
                    _setLinkButtonKxDepositVisible = false;
                    _setLabelKx = props.StatusDescription + ". If this was not your intent, please contact Accommodation Services.";
                }
                break;
            default:
                break;
        }

        if (_setLabelKx !== undefined && _setLabelKx !== null && _setLabelKx !== "") {
            _setLabelKx = _setLabelKx.trim();

            if (!_setLabelKx?.trim().endsWith('.')) {
                _setLabelKx += '.';
            }
        }

        setLabelKx(_setLabelKx);
        setLinkButtonKx(_setLinkButtonKx);
        setLinkButtonKxDeposit(_setLinkButtonKxDeposit);
        setLabelKxTitleVisible(_setLabelKxTitleVisible);
        setLabelKxVisible(_setLabelKxVisible);
        setHyperlinkKxDefaultVisible(_setHyperlinkKxDefaultVisible);
        setLinkButtonKxVisible(_setLinkButtonKxVisible);
        setLinkButtonKxDepositVisible(_setLinkButtonKxDepositVisible);

    }, [{ ...props }]);

    let navLink = "";

    if (props.StatusFlag === "APPLY" || props.StatusFlag === "APPLYINCOMPLETE") {
        navLink = props.NavTo;
    } else {
        navLink = ConstantImport.KXLinkURL + props.KxStudentGuid;
    }

    return <>
        {LabelKxTitleVisible && <p><b>My Accommodation Applications Status:</b></p>}
        {LabelKxVisible && <p>{LabelKx}</p>}
        <p>&nbsp;</p>
        {HyperlinkKxDefaultVisible && <p><NewTabLink to="http://www.essex.ac.uk/accommodation/">Accommodation Services website</NewTabLink></p>}
        {LinkButtonKxVisible &&
            navLink.includes('http')
            ?
            <p><NewTabLink to={navLink}>{LinkButtonKx}</NewTabLink></p>
            :
            <p><Link to={navLink}>{LinkButtonKx}</Link></p>
        }
        {LinkButtonKxDepositVisible && <p><NewTabLink to={navLink}>{LinkButtonKxDeposit}</NewTabLink></p>}
    </>
}